import React, { Fragment } from 'react';
import { Route } from 'react-router'; // react-router v4
import LoginPage from 'src/container/login/LoginPage';
import RegisterPage from 'src/container/login/RegisterPage';
import PasswordForgetPage from 'src/container/login/PasswordForgetPage';

export const RegisterRoutes = (props: any) => {
  return (
    <Fragment>
      <Route exact path="/register" render={() => <RegisterPage {...props} />} />
      <Route exact path="/forget" render={() => <PasswordForgetPage {...props} />} />
      <Route exact path="/login" render={() => <LoginPage {...props} />} />
    </Fragment>
  );
};
